import { render } from "./BundleOrPromoTagAndButton.vue?vue&type=template&id=7afaef6e&scoped=true"
import script from "./BundleOrPromoTagAndButton.vue?vue&type=script&lang=js"
export * from "./BundleOrPromoTagAndButton.vue?vue&type=script&lang=js"

import "./BundleOrPromoTagAndButton.vue?vue&type=style&index=0&id=7afaef6e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afaef6e"]])

export default __exports__